var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestoreIcon = function SvgRestoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.858 4.233a5.062 5.062 0 1 1 7.16 7.16h-.001a5.05 5.05 0 0 1-3.579 1.483A.562.562 0 1 0 8.437 14a6.17 6.17 0 0 0 4.376-1.813A6.187 6.187 0 1 0 2.25 7.813c0 .26.012.628.027 1l-.955-.956a.563.563 0 0 0-.795.796l1.989 1.988a.56.56 0 0 0 .795 0L5.3 8.653a.563.563 0 0 0-.796-.796L3.41 8.952a29 29 0 0 1-.035-1.139c0-1.297.494-2.591 1.483-3.58m4.128 1.158a.548.548 0 0 0-1.097 0v3.602l1.426 1.426a.548.548 0 1 0 .776-.776L8.986 8.538z",
    clipRule: "evenodd"
  })));
};
export default SvgRestoreIcon;